import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { getTasksAndGoalsQuery } from "../../api"
export function PersonalTasksAndGoals({ }) {
  const { t } = useTranslation();

  const {
    data: tasks,
    isLoading,
  } = useQuery({ ...getTasksAndGoalsQuery() });


  const getStatusBadge = (status) => {
    if (!status) return null;

    switch (status) {
      case "DONE":
        return <div className="personal-task-badge done">{t("Done", "Suoritettu")}</div>;

      case "LATE":
        return <div className="personal-task-badge late">{t("Late", "Myöhässä")}</div>;

      case "OPEN":
        return <div className="personal-task-badge open">{t("Open", "Avoin")}</div>;

      case "MODEL":
        return <div className="personal-task-badge model">{t("Model", "Malli")}</div>;

      case "NEWMODEL":
        return <div className="personal-task-badge newmodel">{t("New Model", "Uusi malli")}</div>;
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <>
      <h4 style={{ color: "var(--heeros-blue)" }}>
        {t("TasksAndGoals", "Tehtävät ja tavoitteet")}
      </h4>

      <div className="personal-tasks-list mt-4-5">

        {!isLoading && tasks?.length > 0 && tasks.map((task) => (
          <Card
            key={task.id}
            className="shadow-sm rounded-3 mb-3 border-0"
            style={{ overflow: "hidden" }}
          >
            <div className="d-flex flex-column flex-sm-row p-3">

              <div
                className="d-flex align-items-center justify-content-center rounded p-2 mb-2 mb-sm-0 me-sm-3"
                style={{
                  backgroundColor: "#f8f9fa",
                  minWidth: "85px",
                  height: "fit-content",
                  border: "1px solid #e9ecef"
                }}
              >
                <span style={{ fontWeight: "700", fontSize: "0.9rem", color: "#495057" }}>
                  {formatDate(task.dueDate)}
                </span>
              </div>


              <div className="flex-grow-1 w-100">

                <div className="d-flex justify-content-between align-items-start mb-1">

                  <h6 className="mb-0 me-2" style={{ fontWeight: "700", color: "#212529", lineHeight: "1.4" }}>
                    {task.description}
                  </h6>
                  <div className="flex-shrink-0">
                    {getStatusBadge(task.status)}
                  </div>
                </div>

                <div className="text-muted" style={{ fontSize: "0.85rem", lineHeight: "1.4" }}>
                  {task.title}
                </div>

              </div>

            </div>
          </Card>
        ))}

      </div>
    </>
  );
}
